import React from "react";
import { Col, Row } from "react-bootstrap";
import { ProtocolInfo } from "../../components/Protocols/ProtocolInfo";
import { DeletedVisitViewer } from "../../components/Protocols/Tracking/DeletedVisitViewer";
import { ProtocolProvider } from "../../containers/Protocols/ProtocolContext/ProtocolProvider";

export const DeletedVisitView = props => {
    const { match: { params: { protocolId, logId } } } = props;

    return (
        <ProtocolProvider protocolId={protocolId}>
            <Row>
                <Col md={12} lg={12}>
                    <ProtocolInfo />
                </Col>
                <Col md={12} lg={12}>
                    <DeletedVisitViewer logId={logId} />
                </Col>
            </Row>
        </ProtocolProvider>
    );
}
